export default __webpack_public_path__ + "static/media/periodo-dias.5d0ba98f.gif";